import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GuestForgotPINUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.guestForgotPIN(req);
    }
}
export default GuestForgotPINUseCase;
